import logo from './logo.svg';
import './App.css';
import ShopifyvWebsite from './ShopifyvWebsite';

function App() {
  return (<ShopifyvWebsite/>);
}

export default App;
